"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftCreateContainer = void 0;
const react_1 = __importStar(require("react"));
const DraftForm_1 = require("./DraftForm");
const context_1 = require("../../../shared/context");
const sdk_1 = require("../../sdk");
const DraftCreate = ({ onCreate }) => {
    return (react_1.default.createElement("div", { className: "draft-edit" },
        react_1.default.createElement("div", { className: "draft-edit__actions" },
            react_1.default.createElement("a", { href: '/drafts' }, "\u2191 Back to the drafts")),
        react_1.default.createElement(DraftForm_1.DraftForm, { onSubmit: onCreate, type: DraftForm_1.DraftFormType.Create })));
};
exports.DraftCreateContainer = () => {
    const ctx = react_1.useContext(context_1.AppContext);
    if (!ctx.user) {
        return react_1.default.createElement("div", null, "Sign in to create drafts");
    }
    return (react_1.default.createElement(DraftCreate, { onCreate: (title, content) => {
            sdk_1.sdk.createDraft(title, content)
                .then((draft) => window.routerHistory.push(`/drafts/${draft.id}`))
                .catch(sdk_1.sdk.reportClientError);
        } }));
};
//# sourceMappingURL=DraftCreate.js.map